module.exports = __webpack_public_path__ + "static/img/3.306d219.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/3.png
// module id = TwWZ
// module chunks = 0